/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const chip_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#chip_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12 1.5v2.25M6.75 1.5v2.25m10.5-2.25v2.25M12 22.5v-2.25M6.75 22.5v-2.25m10.5 2.25v-2.25M22.5 12h-2.25m2.25 5.25h-2.25m2.25-10.5h-2.25M1.5 12h2.25M1.5 17.25h2.25M1.5 6.75h2.25m0 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5m-3 3V12m0 0v5.25m0 0v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5m0 0H12m0 0h5.25m0 0h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.5m0 0V12m0 0V6.75m0 0v-1.5a1.5 1.5 0 0 0-1.5-1.5h-1.5m0 0H12m0 0H6.75m1.5 3h7.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-7.5a1.5 1.5 0 0 1-1.5-1.5v-7.5a1.5 1.5 0 0 1 1.5-1.5Z"
      />
    </g>
    <defs>
      <clipPath id="chip_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default chip_medium
